import React, { useState, useEffect } from "react";
import adminApi from '../../assets/constants/AdminRafservice.Instance';
import { connect } from 'react-redux';
import { dateTimeAdminFormatRender, anchorTagEditMode, statusToFormatRender } from '../../assets/constants/customRender'
import AdminSubHeader from '../../components/home/header/adminSubHeader';
import CardComponent from "../../components/Cards/card";
import ExpandableGridTable from "../../components/TableGrids/ExpandableGridTable.table";
import ServerSideGridTable from "../../components/TableGrids/ServerSideGridTable.table";
import AdminSlider from '../../components/home/header/adminSlider';
import AddPolicy from '../../components/Dialog/AddPolicy';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { purple, red } from '@mui/material/colors';
import Swal from 'sweetalert2';
import Tooltip from '@mui/material/Tooltip';
import { toast } from 'react-toastify';

const PolicyPage = (props) => {
    const [policyData, setPolicyData] = useState([]);
    const [open, setOpen] = useState(false);
    const [editPolicyData, setEditPolicyData] = useState({});

    const policyColumn = [
        {
            name: "policy_name",
            label: "Policy Name",
        },
        {
            name: "description",
            label: "Policy Description",
        },
        {
            name: "status",
            label: "Status",
            options: statusToFormatRender
        },
        {
            name: "createdAt",
            label: "Created At",
            options: dateTimeAdminFormatRender
        },
        {
            name: "updatedAt",
            label: "Updated At",
            options: dateTimeAdminFormatRender
        },
        {
            name: "id",
            label: "Action",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <>
                            <Tooltip title="Edit Policy"><a className="hyperlink" style={{ cursor: "pointer" }} onClick={() => handleClickOpen(value)}><ModeEditOutlineIcon color="primary" /></a></Tooltip>
                            <Tooltip title="Delete Policy"><a className="hyperlink" style={{ cursor: "pointer" }} onClick={() => handleClickDelete(value)}><DeleteRoundedIcon sx={{ color: red[500] }} /></a></Tooltip>
                        </>
                    );
                }
            }
        },
    ];
    useEffect(() => {
        loadPolicyData();
    }, [
    ]);

    const handleClickOpen = (value = '') => {
        setOpen(true);
        if (value && value != '') {
            editLoadPolicyData(value)
        } else {
            setEditPolicyData({});
        }
    };

    const handleClickDelete = (value) => {
        if (value && value != '') {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this record!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                confirmBtnBsStyle: "success",
                cancelButtonText: 'No, cancel!',
                cancelBtnBsStyle: "danger",
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    adminApi.delete('/policy/' + value)
                        .then(res => {
                            Swal.fire({
                                title: 'Deleted!',
                                text: 'Your record has been deleted.',
                                icon: 'success',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                    cancelButton: 'btn btn-danger',
                                }
                            })
                            loadPolicyData();
                        })
                        .catch(err => {
                            toast.error(err?.response?.data?.message);
                        })
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.fire({
                        title: 'Cancelled',
                        text: 'Your record is safe :)',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                            cancelButton: 'btn btn-danger',
                        }
                    })
                }
            })
        }
    };

    const handleClose = () => {
        setOpen(false);
        setEditPolicyData({});
    };

    const editLoadPolicyData = (value) => {
        adminApi.get('/policy/' + value)
            .then(res => {
                setEditPolicyData(res.data);
            })
            .catch(err => {
                toast.error(err?.response?.data?.message);
            })
    }

    const loadPolicyData = () => {
        adminApi.get('/policy')
            .then(res => {
                setPolicyData(res.data);
            })
            .catch(err => {
                toast.error(err?.response?.data?.message);
            })
    }

    useEffect(() => {
    }, [
    ]);

    return (
        <div className="container level-summary">
            <div className="row">
                <AdminSubHeader title={'Policy'} />
                <div className='col-lg-12 pr-0 pl-0'>
                    <div className="list-member mt-4">
                        <CardComponent
                            heading={`Policy`}
                            body={
                                <>
                                    <div>
                                        <AddPolicy loadPolicyData={loadPolicyData} editPolicyData={editPolicyData} open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                                    </div>
                                    <ExpandableGridTable
                                        data={policyData}
                                        columns={policyColumn}
                                        pagination={true}
                                    ></ExpandableGridTable>
                                </>

                            }></CardComponent>
                    </div>
                </div>
            </div>
        </div>
    )
};
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
    };
}
export default connect(mapStateToProps)(PolicyPage);
